import type { NotificationResource } from '../../../api/notifications'
import { getNotificationFallbackTitle, getNotificationPreviewMessage } from './utils'

/** Заголовок превью в EventsMenu — тип события, не название проекта. */
export function getNotificationMenuTitle(n: NotificationResource): string {
  return getNotificationFallbackTitle(n)
}

/** Однострочное/короткое превью тела в EventsMenu. */
export function getNotificationMenuMessage(n: NotificationResource): string {
  return getNotificationPreviewMessage(n)
}
